export default {
  state: {
    statusList: [
      { id: 'available', name: 'Available' },
      { id: 'claimed', name: 'Claimed' },
      { id: 'revision-needed', name: 'Revision Needed' },
      { id: 'pending-review', name: 'Pending Review' },
      { id: 'approved', name: 'Approved' },
      { id: 'exported', name: 'Exported' },
    ],
  },
  getters: {
    statusList(state) {
      return state.statusList
    },
    statusNamebyID: state => id => {
      return state.statusList.find(statis => statis.id === id).name
    },
  },
}
